import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'How do I receive the package after purchasing?',
  a: 'You will receive immediate access to all the material so you can start using it right away — no waiting, no complicated steps. Everything downloads as PDF files ready to open, read and teach.'
}, {
  q: 'What level of Spanish teacher is this for?',
  a: 'Spanish Teacher Ready is designed for middle school and high school Spanish teachers — whether you are in your first year or your twentieth. If you teach Spanish 1 or Spanish 2, this system is built for you.'
}, {
  q: 'Does this work for teachers in any country?',
  a: "Yes. Spanish Teacher Ready is written in English and designed for teachers in English-speaking countries who teach Spanish to middle and high school students. It works regardless of your school's specific curriculum framework."
}, {
  q: 'Can I edit the material?',
  a: 'The material is delivered as PDF files. You can print, display and use every lesson exactly as written — which is the point. The system is designed so that you open it and teach without needing to edit anything.'
}, {
  q: 'What currency will I pay in?',
  a: 'You pay in your local currency. The amount adjusts automatically based on your country.'
}, {
  q: "What if it's not useful for me?",
  a: 'Contact us within 7 days of purchase and we will refund 100% of your money with no questions asked.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-navy-card" data-id="element-79" data-mp="s0vxgiwbuenw">
      <div className="max-w-3xl mx-auto" data-id="element-80" data-mp="wxcoplytp957">
        <div className="text-center mb-16" data-id="element-81" data-mp="wyfcvm4rgxhf">
          <h2 className="text-3xl md:text-5xl font-serif font-bold" data-id="element-82" data-mp="ixuuus6o75oz">
            ❓ Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4" data-id="element-83" data-mp="mzgeqxhmgk8o">
          {faqs.map((faq, index) => <div key={index} className="bg-black border border-navy-border rounded-xl overflow-hidden" data-id="element-84" data-mp="2pmwybu4tulal" data-mpi={index}>
              <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-85" data-mp="2kttzb6ha6jn0">
                <span className="font-bold text-lg text-white pr-8" data-id="element-86" data-mp="38l93z5wj5d1f">
                  {faq.q}
                </span>
                <ChevronDown className={`text-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-87" data-mp="33m4yoqcq7zgd" />
              </button>

              <AnimatePresence data-id="element-88" data-mp="2umhujwsm4fjm">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-89" data-mp="1n7wmnppl18iz">
                    <div className="px-6 pb-5 text-gray-300 border-t border-navy-border/50 pt-4" data-id="element-90" data-mp="cggrp70w8s5d">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}